/* ==========================================================================
   Kaufwerk – Teilen-Button
   ========================================================================== */
(function () {
  'use strict';

  const theme = (window.theme = window.theme || {});

  /* ---------- Teilen ---------- */
  class ShareButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('.share-button__status');
      this.button.addEventListener('click', () => this.share());
    }

    async share() {
      const data = { title: this.dataset.title, url: this.dataset.url };
      if (navigator.share) {
        try {
          await navigator.share(data);
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(data.url);
        if (this.status) {
          this.status.textContent = theme.strings.linkCopied || '';
          window.setTimeout(() => (this.status.textContent = ''), 3000);
        }
      } catch (error) {
        window.prompt('', data.url);
      }
    }
  }
  if (!customElements.get('share-button')) customElements.define('share-button', ShareButton);

})();
